import { render, staticRenderFns } from "./ProductRuleCreate.vue?vue&type=template&id=ee92458a&"
import script from "./ProductRuleCreate.vue?vue&type=script&lang=js&"
export * from "./ProductRuleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports